<template>
  <lowerControllers
    :gtm="gtm"
    :hasPreviousSlide="hasPreviousSlide"
    :hasNextSlide="hasNextSlide"
    @previous="previous()"
    @next="next()"
    />
</template>

<script>
  import lowerControllers from './controller-previous-next-overlay.vue';
  import KeyCodes from "../../../utils/key-codes.js";

  export default {

    components: {
      lowerControllers
    },

    props: {
      previousUrl: {type: String, required: false },
			nextUrl: {type: String, required: false },
      gtm: {type: String, required: false },
    },

    computed: {
      hasNextSlide() {
        return this.nextUrl !== null;
      },

      hasPreviousSlide() {
        return this.previousUrl !== null;
      }
    },

    created: function () {
      window.addEventListener('keydown', this.navigate);
    },

    destroyed() {
      window.removeEventListener('keydown', this.navigate);
    },

    methods: {
      previous() {
        window.location = this.previousUrl;
      },

      next() {
        window.location = this.nextUrl;
      },

      navigate: function(e) {
        if (e.keyCode === KeyCodes.LEFT && this.previousUrl !== null) {
          this.previous();
        } else if   (e.keyCode === KeyCodes.RIGHT && this.nextUrl !== null) {
          this.next();
        }
      },

      todo() {
        //see if installation-image-slideshow can also use this component. Will have to use emit for that to work.
      }
    }
  };
</script>
